import * as React from 'react';
import {StyleSheet, View, Linking} from 'react-native';
import {LogoSVG} from '../../assets/images';
import {Image} from '../../shared/components/image';
import {Button} from '../../shared/components/button';
import {useDimensions} from '../hooks/useDimensions';
import {useDeviceSize, DeviceSize} from '../../shared/theme/helpers';
import {deepLinkScheme} from '../constants';

interface Props {
  link: string;
}

// Converts a link parameter to an Eskso deep link
// Example: link=confirmation?op=...&code=... → eskso:confirmation?op=...&code=...
const toEsksoDeepLink = (linkParam: string) => {
  const decoded = decodeURIComponent(linkParam)
    .replace(/^\//, '')
    .replace(/^\?link=/, '');

  return `${deepLinkScheme}/${decoded}`;
};

export default ({link}: Props) => {
  const action = toEsksoDeepLink(link);
  const {height} = useDimensions();
  const deviceSize = useDeviceSize();
  const styles = StyleSheet.create({
    container: {
      height,
      alignItems: 'center',
      justifyContent: 'center',
    },
    bgImage: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
    button: {
      width: 240,
    },
    imageContainer: {
      width: deviceSize === DeviceSize.desktop ? 173 : 130,
      height: deviceSize === DeviceSize.desktop ? 147 : 103,
    },
  });

  const onClick = () => {
    Linking.openURL(action);
  };
  const imageSizes = {
    width: deviceSize === DeviceSize.desktop ? 173 : 130,
    height: deviceSize === DeviceSize.desktop ? 147 : 103,
  };

  return (
    <View style={styles.container}>
      <View style={styles.imageContainer}>
        <Image
          source={LogoSVG as any}
          height={imageSizes.height}
          width={imageSizes.width}
          style={{width: imageSizes.width, height: imageSizes.height}}
        />
      </View>
      <Button id='goto-app' text='Открыть приложение' type='primary' style={styles.button} onPress={onClick} />
    </View>
  );
};
